/* ════════════════════════════════════════════════════════════════════
   Cell Devices — Device OS layer
   File: assets/cd-os.js  (v1.0)
   Shared behaviours for every page:
     · CDOS.notify(title, msg, icon, opts)  — iOS-style toast
     · CDOS.statusNow()                     — one schedule, everywhere
     · Resume-quote banner                  — continues a saved quote
   Safe to include multiple times (self-guarding). No dependencies.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.CDOS) return;
  var CDOS = window.CDOS = { version: '1.0' };

  /* ── One schedule to rule them all ─────────────────────────────── */
  var SCHEDULE = {0:[11,17], 1:[9,18], 4:[9,18], 5:[9,18], 6:[9,18]};
  var DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  function openLabel(d) { return SCHEDULE[d][0] === 11 ? '11am' : '9am'; }

  CDOS.statusNow = function () {
    var now = (window.cdLondonNow ? cdLondonNow() : new Date());
    var day = now.getDay();
    var h = now.getHours() + now.getMinutes() / 60;
    var win = SCHEDULE[day];
    var online = !!(win && h >= win[0] && h < win[1]);
    var msg;
    if (online) {
      msg = 'We\'re online now';
    } else if (win && h < win[0]) {
      msg = 'We\'re offline · Back at ' + openLabel(day) + ' today';
    } else {
      var next = day;
      for (var i = 1; i <= 7; i++) { next = (day + i) % 7; if (SCHEDULE[next]) break; }
      msg = 'We\'re offline · Back ' + DAY_NAMES[next] + ' at ' + openLabel(next);
    }
    return { online: online, msg: msg };
  };

  /* Auto-populate any element marked data-cdos-status.
     Optional children: [data-cdos-status-dot], [data-cdos-status-text]. */
  function initStatus() {
    var els = document.querySelectorAll('[data-cdos-status]');
    if (!els.length) return;
    var s = CDOS.statusNow();
    els.forEach(function (el) {
      var dot = el.querySelector('[data-cdos-status-dot]');
      var txt = el.querySelector('[data-cdos-status-text]');
      if (dot) dot.style.background = s.online ? '#22c55e' : '#94a3b8';
      if (txt) txt.textContent = s.msg;
      el.setAttribute('data-cdos-online', s.online ? 'yes' : 'no');
    });
  }

  /* ── Notification toast ────────────────────────────────────────── */
  var notifEl = null, notifTimer = null, notifClick = null;
  function ensureNotif() {
    if (notifEl) return notifEl;
    notifEl = document.createElement('div');
    notifEl.className = 'cdos-notif';
    notifEl.innerHTML =
      '<div class="cdos-notif__icon" data-cdos-n-icon>📱</div>' +
      '<div><span class="cdos-notif__app" data-cdos-n-app>CELL_DEVICES</span>' +
      '<span class="cdos-notif__msg" data-cdos-n-msg></span></div>';
    notifEl.addEventListener('click', function () {
      if (typeof notifClick === 'function') { var fn = notifClick; notifClick = null; hideNotif(); fn(); }
    });
    document.body.appendChild(notifEl);
    return notifEl;
  }
  function hideNotif() {
    if (notifEl) notifEl.classList.remove('show');
  }
  CDOS.notify = function (app, msg, icon, opts) {
    opts = opts || {};
    var n = ensureNotif();
    n.querySelector('[data-cdos-n-app]').textContent = app || 'CELL_DEVICES';
    n.querySelector('[data-cdos-n-msg]').textContent = msg || '';
    if (icon) n.querySelector('[data-cdos-n-icon]').textContent = icon;
    notifClick = opts.onTap || null;
    n.classList.toggle('cdos-notif--tap', !!notifClick);
    n.classList.add('show');
    if (notifTimer) clearTimeout(notifTimer);
    notifTimer = setTimeout(hideNotif, opts.duration || 3200);
  };

  /* ── Resume-quote banner ───────────────────────────────────────── */
  var QUOTE_PATH = window.CDOS_QUOTE_URL || '/pages/get-a-quote';
  var STATE_KEY = 'cd_quote_state';
  var DISMISS_KEY = 'cd_quote_resume_dismissed';
  var MAX_AGE = 72 * 60 * 60 * 1000; /* 72h */

  function readState() {
    try {
      var raw = localStorage.getItem(STATE_KEY);
      if (!raw) return null;
      var st = JSON.parse(raw);
      if (!st || !st.model || !st.ts) return null;
      if (Date.now() - st.ts > MAX_AGE) return null;
      return st;
    } catch (e) { return null; }
  }

  function initResumeBanner() {
    /* Never on the calculator page itself — the tool handles its own resume. */
    if (window.location.pathname.indexOf(QUOTE_PATH) === 0) return;
    /* WEB-006 — nor anywhere a quote journey is on the page (the calculator embedded as a block), so it never
       sits over the journey it offers to resume. */
    if (document.querySelector('.cdmc, #cdmc-s1')) return;
    var st = readState();
    if (!st) return;
    try {
      var dismissed = localStorage.getItem(DISMISS_KEY);
      if (dismissed && st.ts <= parseInt(dismissed, 10)) return;
    } catch (e) {}

    // WEB-035 review (N4) — rebuild the handle from the saved FULL model name with the calculator's
    // rule ('+' → '-plus'): a Galaxy S24+ quote saved by an older build stored 'galaxy-s24', which
    // now names the base S24. Fall back to the stored handle only when no name was saved.
    var mh = st.model ? String(st.model).toLowerCase().replace(/\+/g, '-plus').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') : (st.mh || '');
    var url = QUOTE_PATH + '?model=' + encodeURIComponent(mh);
    if (st.fault) url += '&fault=' + encodeURIComponent(st.fault);
    if (st.intent) url += '&intent=' + encodeURIComponent(st.intent);

    var what = st.fault ? (st.fault.replace(/-/g, ' ') + ' quote') : 'quote';
    var bar = document.createElement('div');
    bar.className = 'cdos-resume';
    bar.innerHTML =
      '<span class="cdos-resume__ic">🔄</span>' +
      '<span class="cdos-resume__txt">' +
        '<span class="cdos-resume__label">Pick up where you left off</span>' +
        '<a class="cdos-resume__link" href="' + url + '">Continue your ' + st.model + ' ' + what + ' →</a>' +
      '</span>' +
      '<button type="button" class="cdos-resume__x" aria-label="Dismiss">✕</button>';
    var clear = function () { if (window.cdBottomClearance) window.cdBottomClearance(); };   // WEB-006
    bar.querySelector('.cdos-resume__x').addEventListener('click', function () {
      bar.classList.remove('show');
      try { localStorage.setItem(DISMISS_KEY, String(st.ts)); } catch (e) {}
      clear();
    });
    document.body.appendChild(bar);
    setTimeout(function () { bar.classList.add('show'); clear(); }, 600);
  }

  /* ── Boot ──────────────────────────────────────────────────────── */
  function boot() { initStatus(); initResumeBanner(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();